var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntro2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 53.7656V26.25C19.25 25.2554 19.6451 24.3016 20.3484 23.5984C21.0516 22.8951 22.0054 22.5 23 22.5H98C98.9946 22.5 99.9484 22.8951 100.652 23.5984C101.355 24.3016 101.75 25.2554 101.75 26.25V53.7656C101.75 93.1406 68.3281 106.172 61.6719 108.375C60.9157 108.655 60.0843 108.655 59.3281 108.375C52.6719 106.172 19.25 93.1406 19.25 53.7656Z",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.125 48.75L53.6094 75L39.875 61.875",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro2);
export default __webpack_public_path__ + "static/media/intro_2.834032603705a1dc395a3723f07ac8aa.svg";
export { ForwardRef as ReactComponent };